import { MButton } from '@Components/Base';
import Flex from 'antd/es/flex';
import Space from 'antd/es/space';
import Text from 'antd/es/typography/Text';
import classNames from 'classnames';
import { FC, useMemo } from 'react';
import { useFormikContext } from 'formik';
import styles from './PriceSelectionFooter.module.css';
import { ComparisonSheetState } from '../ComparisonSheet.types';

interface PriceSelectionProps {
  finalAmount: number;
  onCancel: () => void;
  onApprove: () => void;
}
const PriceSelectionFooter: FC<PriceSelectionProps> = ({
  finalAmount,
  onApprove,
  onCancel,
}) => {
  const formik = useFormikContext<ComparisonSheetState>();

  // TODO: refactor.
  const uniqSelectionNumber = useMemo(() => {
    const uniq = formik.values.selectedOffersIDs?.length
      ? Array.from(
          new Map(
            formik.values.selectedOffersIDs.map(({ matId, vendorId }) => [
              matId,
              vendorId,
            ])
          ).keys()
        ).length
      : 0;
    return uniq;
  }, [formik.values.selectedOffersIDs]);

  return (
    <Flex justify="space-between" className={classNames(styles.footer)}>
      <Space>
        <Text>
          Final Amount ({uniqSelectionNumber || 0} of{' '}
          {formik.values.allOffers?.length || 0} selected)
        </Text>
        <Text strong>{finalAmount} AED</Text>
      </Space>
      <Space>
        <MButton type="secondary" onClick={() => onCancel()}>
          Cancel
        </MButton>
        <MButton type="primary" onClick={() => onApprove()}>
          Approve
        </MButton>
      </Space>
    </Flex>
  );
};
export default PriceSelectionFooter;
